import { jsxs as s, Fragment as h, jsx as n } from "react/jsx-runtime";
import * as i from "react";
import { memo as m, useState as f } from "react";
import { Drawer as v } from "antd";
import { I as d } from "../../../../AntdIcon-DR2yozD3.js";
import { R as p } from "../../../../CloseOutlined-CEtTmi9p.js";
var u = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74z" } }] }, name: "sliders", theme: "outlined" };
function o() {
  return o = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var c in r)
        Object.prototype.hasOwnProperty.call(r, c) && (t[c] = r[c]);
    }
    return t;
  }, o.apply(this, arguments);
}
const g = (t, e) => /* @__PURE__ */ i.createElement(d, o({}, t, {
  ref: e,
  icon: u
})), l = /* @__PURE__ */ i.forwardRef(g);
process.env.NODE_ENV !== "production" && (l.displayName = "SlidersOutlined");
const O = ({ children: t }) => {
  const [e, r] = f(!1), c = () => {
    r(!0);
  }, a = () => {
    r(!1);
  };
  return /* @__PURE__ */ s(h, { children: [
    /* @__PURE__ */ s(
      "span",
      {
        className: "at-text-sm at-mr-4 at-cursor-pointer",
        onClick: c,
        children: [
          /* @__PURE__ */ n(l, { className: "at-mr-2" }),
          " 更多篩選條件"
        ]
      }
    ),
    /* @__PURE__ */ n(
      v,
      {
        title: "商品篩選條件",
        onClose: a,
        open: e,
        zIndex: 999999,
        width: "90%",
        placement: "left",
        extra: /* @__PURE__ */ n(p, { onClick: a }),
        forceRender: !0,
        closeIcon: null,
        children: t
      }
    )
  ] });
}, I = m(O);
export {
  I as default
};
